import type { Locale } from '../i18n';

export const DEFAULT_LOCALE: Locale = 'fr';
export const LOCALE_PREFIXES: Locale[] = ['fr', 'en', 'ar'];

export function isLocale(v: string | undefined | null): v is Locale {
  return v === 'en' || v === 'fr' || v === 'ar';
}

/** Strip leading locale segment from pathname */
export function stripLocale(pathname: string): string {
  const parts = pathname.split('/').filter(Boolean);
  if (parts.length && isLocale(parts[0])) {
    const rest = parts.slice(1).join('/');
    return rest ? `/${rest}` : '/';
  }
  return pathname || '/';
}

/** Read locale from pathname; default FR for Algeria */
export function localeFromPath(pathname: string): Locale {
  const first = pathname.split('/').filter(Boolean)[0];
  return isLocale(first) ? first : DEFAULT_LOCALE;
}

/** Prefix a site path with locale (supports `#hash`) */
export function withLocale(locale: Locale, path = '/'): string {
  const hashIdx = path.indexOf('#');
  const hash = hashIdx >= 0 ? path.slice(hashIdx + 1) : undefined;
  const barePath = hashIdx >= 0 ? path.slice(0, hashIdx) : path;
  const clean = barePath.startsWith('/') ? barePath : `/${barePath}`;
  const base = !clean || clean === '/' ? `/${locale}` : `/${locale}${clean}`;
  return hash !== undefined ? `${base}#${hash}` : base;
}

/** Swap locale keeping the same logical path */
export function switchLocalePath(pathname: string, next: Locale): string {
  return withLocale(next, stripLocale(pathname));
}

export function pathWithoutLocale(pathname: string): string {
  return stripLocale(pathname);
}
